import orderQueries from '@apis/queries/orderQueries';
import { useQuery } from '@tanstack/react-query';

function useRecentOrders() {
    const { data } = useQuery(orderQueries.recent());
    return data?.orders;
}

export default useRecentOrders;
